<template>
    <div>
        <div class="recommand">
            <div class="recommand-list" v-for="(item, index) in store">
                <div class="store-name" v-if="item.listPro.length > 0" @click="goStore(item.shop)">
                    <img :src="item.shopLogo | urlProtocol" alt="">
                    <h2>{{item.shopName}}</h2>
                    <div>
                        {{item.floorName}} <span> / {{item.categoryName}}</span>
                    </div>
                </div>
                <template v-if="item.listPro.length == 1">
                    <ul class="product-one">
                        <li v-for="list in item.listPro" @click="goProduct(list.commonId, list.commonNo)">
                            <div class="img-box">
                                <img class="img" :src="list.commonImg | urlProtocol" alt="">
                            </div>
                            <h2>{{list.commonName}}</h2>
                            <template v-if="list.commoNum !== 0">
                                <div class="price">{{list.sellPrice}} <span>{{list.price}}</span></div>
                            </template>
                            <template v-else>
                                <div class="price">卖光了</div>
                            </template>
                        </li>
                    </ul>
                </template>
                <template v-if="item.listPro.length == 2">
                    <ul class="product-two">
                        <li v-for="list in item.listPro" @click="goProduct(list.commonId, list.commonNo)">
                            <div class="img-box">
                                <img class="img" :src="list.commonImg | urlProtocol" alt="">
                            </div>
                            <template v-if="list.commoNum !== 0">
                                <div class="price">{{list.sellPrice}} <span>{{list.price}}</span></div>
                            </template>
                            <template v-else>
                                <div class="price">卖光了</div>
                            </template>
                        </li>
                    </ul>
                </template>
                <template v-if="item.listPro.length == 3">
                    <ul class="product-three">
                        <li v-for="list in item.listPro" @click="goProduct(list.commonId, list.commonNo)">
                            <div class="img-box">
                                <img class="img" :src="list.commonImg | urlProtocol" alt="">
                            </div>
                            <template v-if="list.commoNum !== 0">
                                <div class="price">{{list.sellPrice}} <span>{{list.price}}</span></div>
                            </template>
                            <template v-else>
                                <div class="price">卖光了</div>
                            </template>
                        </li>
                    </ul>
                </template>
                <template v-if="item.listPro.length > 3">
                    <div class="product-list" :id="item.id">
                        <div class="scroll-box" :style="{width: item.width}">
                            <ul>
                                <li v-for="list in item.listPro" @click="goProduct(list.commonId, list.commonNo)">
                                    <div class="img-box">
                                        <img :src="list.commonImg | urlProtocol" alt="">
                                    </div>
                                    <template v-if="list.commoNum !== 0">
                                        <h2>{{list.sellPrice}}</h2>
                                        <span>￥{{list.price}}</span>
                                    </template>
                                    <template v-else>
                                        <h2>卖光了</h2>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>

    import conf from '@/app.conf.json';

    export default {
        name: 'Order',
        props: ['ProductList'],
        data () {
            return {
                bodyHeight: '',
                store: this.ProductList
            }
        },
        // 生命周期钩子
        mounted () {
            this.bodyHeight = window.screen.height + 'px';

            let _this = this;
            setTimeout(() => {

                //_this.navWidth = (750 - 20 * 2) / 4 * _this.navList.length / 50 + 'rem';

                $.loadMod(MOD_URL.iscrollLite).done(function () {

                    let UA = window.navigator.userAgent;

                    let scrollStore = _this.store,
                        scrollLen = scrollStore.length;

                    for (let i = 0; i < scrollLen; i++) {

                        if (scrollStore[i].listPro.length > 3) {

                            scrollStore[i].width = ((200 + 20) * scrollStore[i].listPro.length - 0) / 50 + 'rem';

                            setTimeout(() => {
                                new IScroll('#' + scrollStore[i].id, {
                                    scrollX: true,
                                    scrollY: false,
                                    tap: true,
                                    useTransform: (UA.match(/(MI|vivo|MX);?/i) && UA.match(/(SNEBUY-APP);?/i)) ? false : true,
                                    eventPassthrough: true
                                });
                            }, 1);
                        }
                    }
                });
            }, 20);
        },
        methods: {
            goProduct(id, no) {

                this.$router.push({
                    name: 'Product',
                    params: {
                        commonId: id,
                        commonNo: no
                    }
                });
            },
            goStore(shopId) {
                window.location.href = conf.otherPage.storePage + shopId;
            }
        }
    }
</script>
<style scoped>

    .img {
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .recommand {
        border-top: 44px solid #f1f1f0;

        .store-name {
            height: 132px;
            box-sizing: border-box;
            position: relative;
            padding: 32px 0 20px 0;

            &:after {
                display: block;
                width: 710px;
                height: 1px;
                border-top: 1px solid #f2f2f2;
                position: absolute;
                bottom: 0;
                left: 0;
                content: '';
            }

            &:before {
                content: '';
                display: block;
                background: url("../../assets/arrow-icon.png") 0 0 no-repeat;
                width: 15px;
                height: 28px;
                background-size: 15px 28px;
                position: absolute;
                right: 20px;
                top: 50%;
                margin-top: -14px;
            }

            img {
                display: block;
                overflow: hidden;
                width: 80px;
                height: 80px;
                float: left;
                margin-right: 20px;
            }

            h2 {
                overflow: hidden;
                font-size: 32px;
                color: #222222;
                text-align: left;
            }

            div {
                text-indent: 35px;
                overflow: hidden;
                font-size: 24px;
                color: #ffaa00;
                text-align: left;
                position: relative;

                &:before {
                    content: '';
                    display: inline-block;
                    width: 20px;
                    height: 26px;
                    background: url("../../assets/loca-icon.png") 0 0 no-repeat;
                    background-size: 20px 26px;
                    position: absolute;
                    top: 50%;
                    left: 0;
                    margin-top: -11px;
                }

                span {
                    color: #ccc;
                }

            }
        }

        .product-list {
            height: 260px;
            overflow: hidden;
            position: relative;
            padding-top: 20px;

            .scroll-box {
                position: absolute;
                height: 100%;

                li {
                    margin-right: 20px;
                    width: 200px;
                    span {
                        text-decoration: line-through;
                    }
                }
                .img-box {
                    width: 200px;
                    height: 120px;

                    img {
                        display: block;
                        overflow: hidden;
                        width: 100%;
                        height: 100%;
                    }

                }
            }

            ul {
                height: auto;
                overflow: hidden;
            }

            li {
                float: left;
                margin-right: 10px;
                width: 230px;

                span {
                    font-size: 24px;
                    color: #999999;
                }
            }

            .img-box {
                width: 230px;
                height: 138px;

                img {
                    display: block;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                }
            }

            h2 {
                margin-top: 10px;
                font-size: 30px;
                font-weight: bold;
                color: #ff6600;
            }
        }
    }

    .recommand-list {
        padding: 0 20px 0 20px;
        background: #fff;
        margin-bottom: 10px;

        ul {
            padding-bottom: 20px;
        }
    }

    /*一个商品*/
    .product-one {
        margin-top: 20px;

        .img-box {
            margin: 0 auto;
            width: 710px;
            height: 426px;
        }

        h2 {
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 28px;
            color: #333333;
            font-weight: bold;
        }

        .price {
            font-weight: bold;
            font-size: 32px;
            color: #ff6600;

            span {
                margin-left: 10px;
                font-size: 24px;
                color: #999999;
                text-decoration: line-through;
            }

        }
    }
    /*两个商品*/
    .product-two {
        margin-top: 20px;
        height: auto;
        overflow: hidden;

        li {
            margin-right: 10px;
            float: left;

            &:nth-of-type(2) {
                margin-right: 0;
            }

        }
        .img-box {
            margin: 0 auto;
            width: 350px;
            height: 210px;
        }

        .price {
            margin-top: 10px;
            font-weight: bold;
            font-size: 32px;
            color: #ff6600;

            span {
                margin-left: 10px;
                font-size: 24px;
                color: #999999;
                text-decoration: line-through;
            }

        }
    }

    /*三个商品*/
    .product-three {
        height: auto;
        overflow: hidden;
        margin-top: 20px;

        .img-box {
            margin: 0 auto;
            width: 230px;
            height: 138px;
        }

        li {
            margin-right: 10px;
            float: left;

            &:nth-of-type(3) {
                margin-right: 0;
            }
        }

        .price {
            margin-top: 10px;
            font-weight: bold;
            font-size: 32px;
            color: #ff6600;

            span {
                display: block;
                font-size: 24px;
                color: #999999;
                text-decoration: line-through;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/recommend.vue